import { useDrop } from "react-dnd";
import BrowseConstants from "../../store/browse.constants";
import Button from "../Buttons/Button";
import ScissorsIcon from "../Icons/ScissorsIcon";
import { useState } from "react";

const DropZone = ({
  className,
  accept,
  context,
  onDrop,
  style,
  onClick,
  split,
}) => {
  const [hover, setHover] = useState(false);

  const [{ isOver, canDrop }, dropRef] = useDrop({
    accept,
    drop: (item) => onDrop(item, context),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  return (
    <div
      className={`${className}`}
      ref={dropRef}
      style={{
        width: `${BrowseConstants.DROPZONE_WIDTH}px`,
        height: `${BrowseConstants.THUMBNAIL_HEIGHT}px`,
        transition: "background-color 0.3s ease",
        backgroundColor: isOver && canDrop ? "#f0f0f0" : "transparent",
        ...style,
      }}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {split && hover && (
        <Button className={"flex flex-col items-center s-full"}>
          <div className="h-full" style={{ borderRight: "1px dashed black" }} />
          <ScissorsIcon title="Split" className={"rotate-90 no-shrink"} />
          <div className="h-full" style={{ borderRight: "1px dashed black" }} />
        </Button>
      )}
    </div>
  );
};

DropZone.defaultProps = {
  onDrop: () => {},
  onClick: () => {},
  style: {},
  className: "",
};

export default DropZone;
